/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
} from '@material-ui/core';

import forceFloat from '../../../../util/force-float';
import { sortByAttributeAndOrder } from '../../../../util/sort-data';

const styles = {
  header: {
    fontWeight: 600,
    paddingBottom: '10px',
  },
};

class TableVisualizer extends Component {
  render() {
    const { data, options, locationId } = this.props;

    const mainData = data[0];

    const sortColumn = options.sortByAttribute;
    let sortOrder;
    if (sortColumn) {
      sortOrder = options.sortableAttributes[sortColumn].order === 'desc' ? -1 : 1;
      mainData.data.sort(sortByAttributeAndOrder(sortColumn, sortOrder));
    }

    if (options.formats) {
      const keys = Object.keys(options.formats).reverse();

      mainData.data = mainData.data.map((d) => {
        let className = '';

        keys.forEach((i) => {
            const v = options.formats[i];
            if (d.values[+i] == v[0]) {
                if (className) {
                    className = className + " " +v[1];
                } else {
                    className = v[1];
                }
            }
    
            d.values.splice(+i, 1);
            mainData.columns.splice(+i, 1);
        });
        
        const values = d.values.map((v, i) => {
          if (options.formats[i] === 'number') {
            const float = forceFloat(v);

            return float.toFixed(float % 1 === 0 ? 0 : 2);
          }

          if (options.formats[i] === 'orderID') {
            return v ? (<a rel="noreferrer noopener" target="_blank" href={`/admin/reporting/orders/${locationId}?orderId=${v}&orderType=all`}>Zur Bestellung</a>) : null;
          }

          if (options.formats[i] === 'url') {
            return v ? (<a rel="noreferrer noopener" target="_blank" href={v}>Öffnen</a>) : null;
          }

          return v;
        });

        return {
          ...d,
          className,
          values,
        };
      });
    }

    const tableHead = mainData.columns
      .map(c => <TableCell key={c} style={styles.header}>{c}</TableCell>);

    const tableContent = mainData.data.map(({ values, className }) => {
      const cells = values.map((v, j) => (
        <TableCell style={{ whiteSpace: 'pre-wrap' }} key={j}>
          {(v && v.replace) ? v.replace(/&lt;br&gt;/g, '\n') : v}
        </TableCell>
      ));
      return <TableRow className={className} key={values[0]}>{cells}</TableRow>;
    });

    return (
      <Table padding="checkbox" stickyHeader size="small">
        <TableHead>
          <TableRow>
            {tableHead}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableContent}
        </TableBody>
      </Table>
    );
  }
}

TableVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  locationId: PropTypes.number,
};

TableVisualizer.defaultProps = {
  data: [],
  options: [],
  locationId: null,
};

export default TableVisualizer;
